import type { SvgIconProps } from '@village/icons';
import { SvgIcon } from '@village/icons';
import { forwardRef } from 'react';

export const VisitGuidelinesIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
    <SvgIcon ref={ref} viewBox="0 0 24 24" data-testid="visit-guidelines-icon" {...props}>
        <path
            d="M5.55 19L2 15.45L3.4 14.05L5.525 16.175L9.775 11.925L11.175 13.35L5.55 19ZM5.55 11L2 7.45L3.4 6.05L5.525 8.175L9.775 3.925L11.175 5.35L5.55 11ZM13 17V15H22V17H13ZM13 9V7H22V9H13Z"
            fill="currentColor"
        />
    </SvgIcon>
));
